/**
 * Centralized Configuration
 *
 * Main configuration file that exports all config-related constants and functions.
 */

// Re-export all configuration modules
export * from "./basePath";
export * from "./cookiesNameConfig";
export * from "./endpoints/apiEndpoints";

const DEFAULT_HOST = process.env.NEXT_PUBLIC_DEFAULT_HOST || "localhost";

const APP_VERSION_NAME = process.env.NEXT_PUBLIC_APP_VERSION_NAME;
const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION;

const DEV_SERVER_IP = "76.13.212.252";

const CURRENCY = "£"; // Default currency symbol
const PAGE_SIZE = 20;

const DEFAULT_IDEAL_TIMEOUT_MINUTES = 15;

// Rate limiting defaults (can be overridden via env)
const RATE_LIMIT_REQUESTS_DEFAULT = 60;
const RATE_LIMIT_WINDOW_DEFAULT = 60;

export {
  APP_VERSION,
  APP_VERSION_NAME,
  CURRENCY,
  DEFAULT_HOST,
  DEFAULT_IDEAL_TIMEOUT_MINUTES,
  DEV_SERVER_IP,
  PAGE_SIZE,
  RATE_LIMIT_REQUESTS_DEFAULT,
  RATE_LIMIT_WINDOW_DEFAULT,
};
